/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- MONETIZATION - FULL AD MANAGEMENT PAGE : STYLES --------------- ++++++++++ */
export default {
    fullAdManagement: {
    }
};
